module.exports = __webpack_public_path__ + "img/Butterfly_00334.ba76ea49.png";